





















import { Component, Prop, Vue, Watch, Emit } from 'vue-property-decorator';
// import { DtFormItem } from "src/components";

type Size = 'small' | 'medium' | 'large';

interface InputConfig {
  name?: string,
  size?: Size,
  disabled?: boolean,
  placeholder?: string
  label?: string,
  key?: string,
  inline?: boolean,
  tip?: string,
  validators?: any,
  min?: number,
  max?: number,
  precision?: number,
  step?: number,
  stepStrictly?: boolean,
  controls?: boolean
}

@Component({
  name: 'mcInputNumber',
  components: {
    // DtFormItem
  }
})
export default class extends Vue {
  @Prop({ default: () => [] }) private value!: string | undefined;
  @Prop({ default: () => [] }) private config?: any;
  private currentValue: string = this.value;
  private defaultConfig: any = {
    size: 'medium',
    placeholder: '请输入',
    stepStrictly: false,
    controls: true,
    step: 1
  };

  // 合并默认数据
  get currentConfig() {
    const result = this.config;
    Object.keys(this.defaultConfig).forEach((key: string) => {
      if (this.config[key] === undefined) result[key] = this.defaultConfig[key];
    });
    return result;
  }

  // 检测值
  @Watch("value")
  onValueChanged(val: string) {
    this.currentValue = val;
  }

  /**
   * 输入框值改变
   * @author tanxj
   * @param value 值
   */
  @Emit('on-change')
  handleChange(value: string) {
    this.$emit('input', value);
  }

  /**
   * 失去焦点事件
   * @author tanxj
   * @param any event 事件
   */
  handleBlur(event: any) {
    this.$emit('on-blur', event.target.value, event);
  }

  /**
   * 使input 获取焦点
   * @author tanxj
   * @param any event 事件
   */
  handleFocus(event: any) {
    this.$emit('on-focus', event);
  }
}
